module.exports = __webpack_public_path__ + "img/koch.d22dcc57.png";